import React from 'react';
import PropTypes from 'prop-types';
import { CMS } from '../../utils';
import { Div } from '../../layouts';
import { EntryPoint, TabTypeProp, TabTypePropDefault } from '../../models';

export function LocationNotFound({ activeProduct, displayedWord }) {
    const id = activeProduct === EntryPoint.HOTELS ? 'home.hsaSearch.origin_error_text' : 'citySearch.origin_error_text';
    return (
        <div className="odf-row-fluid odf-space-inner-top-m odf-space-inner-bottom-m odf-space-inner-left-xs odf-space-inner-right-xs">
            <div className="odf-col odf-col-sm">
                <span className="odf-icon odf-icon-interrogation-circle odf-icon-l odf-text-info" />
            </div>
            <Div className="odf-col odf-text-info odf-text-md" whiteSpace="normal">
                <CMS id={id} /> { activeProduct !== EntryPoint.HOTELS && displayedWord }
            </Div>
        </div>
    );
}

LocationNotFound.defaultProps = {
    activeProduct: TabTypePropDefault,
};

LocationNotFound.propTypes = {
    activeProduct: TabTypeProp,
    displayedWord: PropTypes.string.isRequired,
};
